export default "__VITE_ASSET__DnO5sPj6__"